export default __webpack_public_path__ + "static/media/Clinic_Dir_Bio_Norman_Fabula_Tacoma_061621.4fc455ca.pdf";